import clsx from 'clsx'
import React from 'react'

export const ProgressBar = ({
  currentStep = 0,
  lastStep = 1,
  purple = false,
}: {
  currentStep?: number
  lastStep?: number
  purple?: boolean
}) => {
  const progress = Math.min((currentStep / lastStep) * 100, 100)

  return (
    <div
      className={clsx('max-w-[376px] mt-3 mx-auto w-full h-1  rounded-full overflow-hidden', {
        'bg-[#A10D861F]': purple,
        'bg-[#101A3614]': !purple,
      })}
    >
      <div
        className={clsx(
          'h-full  transition-all duration-300 ease-in-out rounded-full relative after:absolute after:left-full after:h-full after:top-0 after:w-[6px] after:bg-black after:rounded-r-[1px] after:-translate-x-1 after:z-[-1] z-[10] before:absolute before:top-0 before:left-0 before:h-full before:w-full before:rounded-full before:z-10',
          {
            'bg-purpleGradient before:bg-purpleGradient': purple,
            'bg-buttonGradient before:bg-buttonGradient': !purple,
          },
        )}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  )
}
